import React from "react";
import { Container } from "react-bootstrap";
import { CREED, SHOP } from "../data/shop";
import { Zia } from "./Zia";
import "./About.css";

export const About = () => (
  <section id="about" className="about">
    <Container>
      <div className="about__grid">
        <div className="about__portrait">
          <div className="about__portrait-frame frame">
            <img
              src="/assets/splashes/ThisChristography-20200613-4.jpg"
              alt="Caped barber chairs lined up inside Randy's Barber Shop"
            />
          </div>
          <div className="about__badge">
            <Zia size={18} />
            <span>Est. {SHOP.established}</span>
            <small>Albuquerque, New Mexico</small>
          </div>
        </div>

        <div className="about__story">
          <span className="eyebrow">Our Story</span>
          <h2 className="section-title">
            Old fashioned
            <br />
            <span className="gold-text">service.</span> Real results.
          </h2>
          <div className="rule mt-4 mb-4">
            <span className="diamond" />
          </div>

          <p>
            Established in 1973 by Randy Sanchez, Randy's Barber Shop has been
            located on Wyoming Blvd serving its community with hot towel shaves
            and gentlemen's cuts 6 days a week, month to month, year to year.
            Randy's Barber Shop continues to provide its services for the four
            generations of families and friends that have made the barber shop
            their own personal get away.
          </p>
          <p>
            In 2020, Randy's Barber Shop became Randy's Barber Shop Inc. Big RJ
            the Barber, new owner-operator and Master Barber, bought the
            business and made it Incorporated to ensure a work place for Randy
            until he is ready to retire. We are looking to keep Randy's a
            staple, not only in the fast-growing Uptown area, but a Landmark for
            the men in the barbering profession and to keep that old school
            barbering heritage alive. Randy's Barber Shop Inc. will continue to
            provide gentlemen's cuts, full hot towel shaves, and beard line ups
            with that old-fashioned feel.
          </p>

          <p className="about__pullquote">
            Where a great cut and a smile can really make you feel at home.
          </p>
        </div>
      </div>

      <div className="about__creed">
        <div className="about__creed-intro">
          <img
            className="about__creed-portrait"
            src="/assets/posters/big-rj.jpg"
            alt="Big RJ, owner and master barber at Randy's Barber Shop"
            width={600}
            height={600}
            loading="lazy"
          />
          <div className="about__creed-copy">
            <span className="eyebrow">The Big RJ Creed</span>
            <p className="about__creed-quote">
              Old fashioned barber giving old fashioned cuts.
            </p>
            <p className="about__creed-attribution">
              Big RJ &mdash; Owner &amp; Master Barber
            </p>
          </div>
        </div>
        <div className="about__creed-grid">
          {CREED.map((value) => (
            <article className="creed-card" key={value.letter}>
              <span className="creed-card__letter gold-text">
                {value.letter}
              </span>
              <h3 className="creed-card__title">{value.title}</h3>
              <p className="creed-card__body">{value.body}</p>
            </article>
          ))}
        </div>
      </div>
    </Container>
  </section>
);
